interface BrandLockupProps {
  /** Render for placement over a dark background (white logo). */
  onDark?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const HEIGHT = { sm: 'h-12', md: 'h-14', lg: 'h-16' } as const;

/**
 * The real freshSTART CDC logo (cut from the board's logo file, tagline removed; masters in
 * design-assets/brand/): white on dark backgrounds, full color on light ones. Reused in
 * Header & Footer.
 */
export const BrandLockup = ({ onDark = false, size = 'md', className = '' }: BrandLockupProps) => {
  const tone = onDark ? 'white' : 'color';
  return (
    <img
      src={`/images/brand/logo-mark-${tone}-320.webp`}
      srcSet={`/images/brand/logo-mark-${tone}-320.webp 320w, /images/brand/logo-mark-${tone}-640.webp 640w`}
      sizes="180px"
      width={640}
      height={231}
      alt="freshSTART CDC"
      className={`${HEIGHT[size]} w-auto ${className}`}
      data-testid="brand-logo"
    />
  );
};
